





































































































































import { Component, Watch, Vue, Prop } from "vue-property-decorator";
import { ILocale } from "@/@types/locale";
import { validationMixin } from "vuelidate";
import { required, numeric } from "vuelidate/lib/validators";
import { configuration } from "@/config/host.config";
import { ICurrency } from "@/@types/currency";

import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import BSwitch from "@/components/app/switchs/b-switch.vue";

@Component({
  components: { btns: SubmitResetButtonGroop, BSwitch },
  mixins: [validationMixin],
  validations: {
    name: { required },
    code: { required, numeric },
    mnemonicCode: { required },
    minorUnits: { numeric },
    unicodeSymbol: { required },
  },
})
export default class AddCurrencyForm extends Vue {
  @Prop({ type: Object, default: null }) item!: ICurrency;

  locale = this.$store.getters.getLanguages.length
    ? this.$store.getters.getLanguages[0]
    : "";

  name = "";
  names: ILocale = {};
  code: number | null = null;
  mnemonicCode = "";
  minorUnits: number | null = null;
  unicodeSymbol = "";
  show = false;
  sort_order = 0;

  get currency(): Partial<ICurrency> {
    return {
      _id: this.item ? this.item._id : "",
      code: this.code ? this.code : 0,
      mnemonicCode: this.mnemonicCode,
      minorUnits: this.minorUnits,
      unicodeSymbol: this.unicodeSymbol,
      fullName: this.names,
      show: this.show,
      sort_order: this.sort_order,
    };
  }

  @Watch("name")
  changeName(): void {
    this.names[this.locale] = this.name;
  }

  @Watch("locale")
  updateName(): void {
    if (this.names)
      this.name = this.names[this.locale] ? this.names[this.locale] : "";
    else this.name = "";
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      this.$v.$touch();
      return;
    }
    this.$emit("updateCurrency", this.currency, this.currency._id);
  }

  onReset(): void {
    this.name = "";
    this.names = {};
    this.code = 0;
    this.mnemonicCode = "";
    this.minorUnits = null;
    this.unicodeSymbol = "";
  }

  @Watch("item")
  createStartParams(): void {
    if (!this.item) return;
    this.names = this.item.fullName;
    this.updateName();
    this.code = this.item.code;
    this.mnemonicCode = this.item.mnemonicCode;
    this.minorUnits = this.item.minorUnits;
    this.unicodeSymbol = this.item.unicodeSymbol;
    this.show = this.item.show;
    this.sort_order = this.item.sort_order;
  }

  isError(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "warn",
    });
  }

  mounted(): void {
    this.createStartParams();
  }
}
